export default __webpack_public_path__ + "static/media/home_jersey.6de7c473.png";